var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VerticalCounterCard',{attrs:{"label":_vm.$t('Component(Statistics):label-suppliers-counters'),"counters":_vm.counters}})}
var staticRenderFns = []

export { render, staticRenderFns }